import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
// S1
import BaseMixer from "@/router/views/BaseMixer";
import { actionItemMatches, textMatches, updateText } from "./updatesHelpers";
import UpdateTimelineItem from "./components/UpdateTimelineItem.vue";
/**
 * The timeline list. Owns which rows are open (kept by id, so a row filtered out by a tab or search
 * comes back as it was) and the single open menu / Read more popover.
 */
let UpdatesTimeline = /** @class */ (() => {
    let UpdatesTimeline = class UpdatesTimeline extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.openDetailIds = [];
            this.openUpdateIds = [];
            this.openMenuId = null;
            this.summaryPopId = null;
        }
        rowClass(index) {
            if (this.entries.length === 1) {
                return "is-first is-last is-only";
            }
            if (index === 0) {
                return "is-first";
            }
            if (index === this.entries.length - 1) {
                return "is-last";
            }
            return "";
        }
        key(entry) {
            return entry.id.toString();
        }
        updateSectionMatches(entry, term) {
            return [updateText(entry.updateHtml), entry.createdByName].some((value) => textMatches(value, term));
        }
        // A search hit inside a collapsed part of the row opens it, so the highlighted match is visible
        onSearchTermChanged() {
            const term = (this.searchTerm || "").trim();
            if (!term) {
                return;
            }
            if (this.collapseUpdates) {
                const hitIds = (this.entries || []).filter((x) => this.updateSectionMatches(x, term)).map((x) => this.key(x));
                this.openUpdateIds = [...this.openUpdateIds, ...hitIds.filter((id) => this.openUpdateIds.indexOf(id) === -1)];
                return;
            }
            const hitIds = (this.entries || []).filter((x) => (x.actionItems || []).some((item) => actionItemMatches(item, term))).map((x) => this.key(x));
            this.openDetailIds = [...this.openDetailIds, ...hitIds.filter((id) => this.openDetailIds.indexOf(id) === -1)];
        }
        // Opening the Action Items tab starts with every update collapsed
        onCollapseUpdatesChanged(collapsed) {
            if (!collapsed) {
                return;
            }
            this.openUpdateIds = [];
            this.summaryPopId = null;
            this.onSearchTermChanged();
        }
        setActionItemStatus(payload) {
            this.$emit("set-action-item-status", payload);
        }
        isDetailOpen(entry) {
            return this.openDetailIds.indexOf(this.key(entry)) > -1;
        }
        toggleDetails(entry) {
            const id = this.key(entry);
            this.openDetailIds = this.isDetailOpen(entry) ? this.openDetailIds.filter((x) => x !== id) : [...this.openDetailIds, id];
        }
        isUpdateShown(entry) {
            return this.openUpdateIds.indexOf(this.key(entry)) > -1;
        }
        toggleUpdate(entry) {
            const id = this.key(entry);
            const shown = this.isUpdateShown(entry);
            this.openUpdateIds = shown ? this.openUpdateIds.filter((x) => x !== id) : [...this.openUpdateIds, id];
            if (shown && this.summaryPopId === id) {
                this.summaryPopId = null;
            }
        }
        toggleMenu(entry) {
            const id = this.key(entry);
            this.openMenuId = this.openMenuId === id ? null : id;
            this.summaryPopId = null;
        }
        closeMenu() {
            this.openMenuId = null;
        }
        toggleSummaryPop(entry) {
            const id = this.key(entry);
            this.summaryPopId = this.summaryPopId === id ? null : id;
            this.openMenuId = null;
        }
        addUpdate() { }
        editUpdate(entry) {
            this.$emit("edit-update", entry);
        }
        deleteUpdate(entry) {
            this.$emit("delete-update", entry);
        }
        onDocumentClick() {
            this.openMenuId = null;
            this.summaryPopId = null;
        }
        mounted() {
            document.addEventListener("click", this.onDocumentClick);
        }
        beforeDestroy() {
            document.removeEventListener("click", this.onDocumentClick);
        }
    };
    __decorate([
        Prop({ default: () => [] }),
        __metadata("design:type", Array)
    ], UpdatesTimeline.prototype, "entries", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UpdatesTimeline.prototype, "isFiltered", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UpdatesTimeline.prototype, "needsTeam", void 0);
    __decorate([
        Prop({ default: true }),
        __metadata("design:type", Boolean)
    ], UpdatesTimeline.prototype, "canAdd", void 0);
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], UpdatesTimeline.prototype, "searchTerm", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UpdatesTimeline.prototype, "statusBusy", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UpdatesTimeline.prototype, "readOnly", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UpdatesTimeline.prototype, "collapseUpdates", void 0);
    __decorate([
        Watch("searchTerm"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UpdatesTimeline.prototype, "onSearchTermChanged", null);
    __decorate([
        Watch("collapseUpdates"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], UpdatesTimeline.prototype, "onCollapseUpdatesChanged", null);
    __decorate([
        Emit("add-update"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UpdatesTimeline.prototype, "addUpdate", null);
    UpdatesTimeline = __decorate([
        Component({
            name: "UpdatesTimeline",
            components: {
                UpdateTimelineItem,
            },
        })
    ], UpdatesTimeline);
    return UpdatesTimeline;
})();
export default UpdatesTimeline;
